module.exports = __webpack_public_path__ + "static/media/empty-event-list.c939b5b6.png";